import API from "@vahak/core/dist/_services/const";
import { ClientHookOptions, useVahakMutationQuery, useVahakQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import queryNames from "../queryNames";
import { generateQueryString } from "@vahak/core/dist/methods/generateQueryString";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";

interface Params {
    companyId: number;
}

interface Response {
    data?: CompanyCashbackData;
}

export interface CompanyCashbackData {
    id?: number;
    membership_status?: number;
    cashback_earned_till_now?: number;
    total_cashback_amount?: number;
    reedemable_cashback_amount?: number;
    blocked_cashback_amount?: number;
    coins_expiring_today?: number;
    total_expired_coins?: number;
}

const buildCompanyCashbackUrl = (params: Params) => {
    return `${API.USER_CASHBACK_DETAILS}&${generateQueryString({
        c_i: params?.companyId
    })}`;
};

export const useGetCompanyCashbackDetailsMutationQuery = () => {
    const { GET } = useVahakHttpClient();
    const method = (params: Params) => GET<Response>(buildCompanyCashbackUrl(params));
    return useVahakMutationQuery<Response, ApiErrorResponseType, Params>(
        [queryNames.getCompanyCashbackDetails],
        method
    );
};

export const useGetCompanyCashbackDetailsQuery = (
    params: Params,
    options: ClientHookOptions<Response, unknown, Response["data"]>
) => {
    const { GET } = useVahakHttpClient();
    const method = () => GET<Response>(buildCompanyCashbackUrl(params));
    return useVahakQuery<Response, unknown, Response["data"]>([queryNames.getCompanyCashbackDetails, params], method, {
        ...options,
        select: (data) => data.data
    });
};
